import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { DiwanSizes } from '../../../models/List.Restaurant';
import { RestaurantService } from '../../../services/Restaurant.service';

export interface DialogData {
  selectedItems: any[],
  restaurantId: number
}

@Component({
  selector: 'app-sizes-form',
  templateUrl: './sizes-form.component.html'
})
export class SizesFormComponent extends DirtyComponent implements OnInit {
  dataLoading = false;
  pageIndex = 0;
  pageCount = 0;

  sizes: DiwanSizes[] = []

  restaurantSizes: any[] = []
  selectedSizes: any[] = []
  selectedSizesCopy: any = []



  lang = localStorage.getItem('language') || 'en';
  categoryList: any[] = [];
  categorySelected?: any;
  searchText?: any;
  override formGroup!: FormGroup;

  subscriptions: Subscription[] = []

  constructor(
    private service: RestaurantService,
    override dialogRef: MatDialogRef<SizesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    super(translate)
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.getAll();
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAll();
        }
      })
    )

    this.restaurantSizes = JSON.parse(JSON.stringify(this.data.selectedItems));
    this.selectedSizesCopy = JSON.stringify(this.selectedSizes);
    this.restaurantSizes.map((item, index) => {
      this.restaurantSizes[index] = item
    })
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  selected(event?: any, item?: any) {
    if (event.checked) {
      this.selectedSizes.push(item)
    } else {
      let findItem = this.selectedSizes.findIndex(x => x.id == item.id)
      this.selectedSizes.splice(findItem, 1)
      console.log('after slice', this.selectedSizes)
    }
  }

  override canDeactivate(): boolean {
    return JSON.stringify(this.selectedSizes).length !== this.selectedSizesCopy.length
  };

  getAll() {
    this.dataLoading = true;
    this.service.GetAllDiwanSizes().subscribe(
      (data: any) => {
        this.dataLoading = false;
        if (data) {
          this.sizes = data.diwanSizes;
          this.sizes.map(item => {
            let findSelected = this.selectedSizes.find(x => x.id == item.id);
            let findRestSelected = this.restaurantSizes.find((x: any) => x.id == item.id);

            item.canSelect = findRestSelected ? false : true
            item.isSelected = (findSelected || findRestSelected) ? true : false
          })

        }
      },
      (error: any) => {
        this.sizes = [];
        this.dataLoading = false;
      });
  }

  isAllHidden() {
    return this.sizes.every(item => this.hideOption(item) || !item.canSelect);
  }

  hideOption(item: any) {
    return new RegExp(this.searchText, 'i').test(item.name) === false
  }

  hasRecordsData() {
    return (
      !this.isAllHidden() &&
      this.sizes
      && this.sizes.length
      && this.restaurantSizes.length != this.sizes?.length
    )
  }

  saveRecord() {
    const selected = this.selectedSizes.filter(item => item.isSelected);
    if (this.selectedSizes.length) {
      this.dialogRef.close(selected);
    }
    else {
      Swal.fire({
        title: this.translate.instant('swalMsg.Warning'),
        text: this.translate.instant('swalMsg.noChangesHappens'),
        icon: 'warning',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
      this.dialogRef.close(true);
    }

  }

}
